<template>
	<div>
		<SectionToolbar v-on:close="$emit('close')" v-for="section in sections" :key="section.name" :response="response" :section="section.name" :current="current"></SectionToolbar>
	</div>
</template>

<style lang="less">
	
</style>

<script type="text/javascript">
	// import Vuex from "vuex";
	import SectionToolbar from "@/components/assessment/SectionToolbar"
	export default {
		name: "SectionNavigation", 
		props: {
			current: {type: String },
			response: {type: Object }, 
		},
		data: () => {
			return {

			}
		},
		components: {
			SectionToolbar
		},
		computed: {
			sections(){

				return window.S.getAllQuestions().filter( q => q.renderAs == "cn_header")
			}
			// ...Vuex.mapState({})
		},
		methods: {
		}
		// created(){Ss
			
		// }

	}
</script>"